import styled from 'styled-components'

export const ModalContainer = styled.div`
  padding: 2rem;
  min-width: 400px;
  max-width: 48rem;
  background-color: ${({ theme }) => theme.palette.background.default};
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

export const Title = styled.h2`
  margin-bottom: 1rem;
  color: ${({ theme }) => theme.palette.text.primary};
`

export const Description = styled.p`
  margin-bottom: 1.5rem;
  color: ${({ theme }) => theme.palette.text.primary};
`

export const FeedbackTextarea = styled.textarea`
  width: 100%;
  margin-bottom: 1.5rem;
  padding: 0.75rem;
  border: 1px solid ${({ theme }) => theme.palette.border.light};
  outline: none;
  border-color: ${({ theme }) => theme.palette.primary.main};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  color: ${({ theme }) => theme.palette.text.primary};
  font-family: inherit;
  font-size: 0.875rem;
  resize: vertical;
  min-height: 100px;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  flex-wrap: wrap;
`

export const SecondaryActions = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin-top: 1rem;
  flex-wrap: wrap;
`

export const TextActionButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 0.875rem;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: ${({ theme }) => theme.palette.text.primary};
  }
`
